import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const NewArrivalsPage = lazy(() => import('../pages/new-arrivals/page'));
const ApparelPage = lazy(() => import('../pages/apparel/page'));
const FootwearPage = lazy(() => import('../pages/footwear/page'));
const AccessoriesPage = lazy(() => import('../pages/accessories/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/product/:id',
    element: <ProductPage />,
  },
  {
    path: '/new-arrivals',
    element: <NewArrivalsPage />,
  },
  {
    path: '/apparel',
    element: <ApparelPage />,
  },
  {
    path: '/footwear',
    element: <FootwearPage />,
  },
  {
    path: '/accessories',
    element: <AccessoriesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;